import { styled } from "@mui/material/styles";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  TableContainer,
  FormControl,
  TextField,
  Select,
  TableHead,
  TableCell,
  Divider,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

export const DialogStyled = styled(Dialog)({
  "& .MuiDialog-paper": {
    borderRadius: "4px",
    maxWidth: "968px",
    height: "787px",
  },
});

export const DialogTitleStyled = styled(DialogTitle)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  padding: "24px",
  background: "#FFFFFF",
  borderBottom: "none",
});

export const DialogTitleContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
  flex: 1,
});

export const DialogTitleText = styled(Typography)({
  fontSize: "20px",
  fontWeight: 500,
  lineHeight: "1.6em",
  letterSpacing: "0.75%",
  color: "rgba(0, 0, 0, 0.87)",
});

export const CloseButton = styled(IconButton)({
  color: "rgba(0, 0, 0, 0.54)",
  marginTop: "-4px",
});

export const DialogContentStyled = styled(DialogContent)({
  padding: "24px",
  height: "100%",
  overflow: "hidden",
});

export const DialogContentNoPadding = styled(DialogContent)({
  padding: 0,
});

export const DialogSubtitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const ContentWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  height: "100%",
  overflow: "auto",
});

export const SectionContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  padding: "16px",
  background: "#FFFFFF",
  borderRadius: "4px",
});

export const SectionTitle = styled(Typography)({
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "1.5em",
  letterSpacing: "0.94%",
  color: "rgba(0, 0, 0, 0.87)",
});

export const FormRow = styled(Box)({
  display: "flex",
  gap: "16px",
});

export const StyledFormControl = styled(FormControl)({
  flex: 1,
  "& .MuiOutlinedInput-notchedOutline": {
    borderStyle: "dashed",
    borderColor: "rgba(0, 0, 0, 0.23)",
  },
});

export const StyledTextField = styled(TextField)({
  flex: 1,
  "& .MuiOutlinedInput-notchedOutline": {
    borderStyle: "dashed",
    borderColor: "rgba(0, 0, 0, 0.23)",
  },
});

export const StyledTextFieldFullWidth = styled(TextField)({
  "& .MuiOutlinedInput-notchedOutline": {
    borderStyle: "dashed",
    borderColor: "rgba(0, 0, 0, 0.23)",
  },
});

export const StyledSelect = styled(Select)({
  "& .MuiOutlinedInput-notchedOutline": {
    borderStyle: "dashed",
    borderColor: "rgba(0, 0, 0, 0.23)",
  },
});

export const DividerStyled = styled(Divider)({
  borderColor: "rgba(0, 0, 0, 0.12)",
});

export const MethodsSectionContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const MethodsTitleContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  padding: "8px 16px",
});

export const MethodsTitle = styled(Typography)({
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "1.66em",
  letterSpacing: "3.33%",
  color: "rgba(0, 0, 0, 0.87)",
});

export const MethodsCheckboxContainer = styled(Box)({
  display: "flex",
  gap: "16px",
  padding: "4px",
});

export const StyledFormControlLabel = styled(FormControlLabel)({
  margin: 0,
  "& .MuiFormControlLabel-label": {
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "1.5em",
    letterSpacing: "0.94%",
    color: "rgba(0, 0, 0, 0.87)",
  },
});

export const StyledCheckbox = styled(Checkbox)({
  "&.Mui-disabled": {
    color: "rgba(0, 0, 0, 0.26)",
  },
});

export const CredentialsSectionContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  padding: "0 16px",
});

export const CredentialsFieldsContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const FlagsSectionContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  padding: "0 16px",
  flex: 1,
});

export const TableContainerStyled = styled(TableContainer)({
  border: "1px solid rgba(224, 224, 224, 1)",
  borderRadius: "4px",
  width: "100%",
});

export const StyledTableHead = styled(TableHead)({
  backgroundColor: "transparent",
});

export const StyledTableCellHeader = styled(TableCell)({
  padding: "16px 24px 16px 16px",
  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  width: "50%",
});

export const StyledTableCellHeaderText = styled(Typography)({
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "1.71em",
  letterSpacing: "1.21%",
  color: "rgba(0, 0, 0, 0.87)",
});

export const StyledTableCellBody = styled(TableCell)({
  padding: "16px",
  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  width: "50%",
});

export const StyledTableCellBodyText = styled(Typography)({
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "1.43em",
  letterSpacing: "1.21%",
  color: "rgba(0, 0, 0, 0.38)",
});

export const DialogActionsStyled = styled(DialogActions)({
  padding: "16px",
  justifyContent: "flex-end",
  gap: "8px",
});

export const StyledCancelButton = styled(Button)({
  textTransform: "uppercase",
  borderRadius: "40px",
  borderColor: "rgba(0, 0, 0, 0.5)",
  color: "#000000",
  fontSize: "15px",
  fontWeight: 500,
  lineHeight: "1.73em",
  letterSpacing: "3.07%",
  padding: "8px 22px",
  "&:hover": {
    borderColor: "rgba(0, 0, 0, 0.5)",
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
});

export const StyledSaveButton = styled(Button)({
  textTransform: "uppercase",
  borderRadius: "40px",
  backgroundColor: "#D33100",
  color: "#FFFFFF",
  fontSize: "15px",
  fontWeight: 500,
  lineHeight: "1.73em",
  letterSpacing: "3.07%",
  padding: "8px 22px",
  boxShadow:
    "0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.2)",
  "&:hover": {
    backgroundColor: "#b02a00",
  },
});
